export default function Reaction2({
  size,
  color,
  className = "",
  onClick = () => {},
  active = false,
}) {
  return (
    <svg
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "0.5s",
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        backgroundColor: active ? "#ffc61e" : "#ffffff",
        borderRadius: "50%",
      }}
      fill={active ? "#ffffff" : color}
      className={className}
      viewBox="0 0 64 64"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
    >
      <path
        stroke={active ? "#ffc61e" : color}
        strokeWidth="1"
        d="M32,3c16,0,29,13,29,29S48,61,32,61S3,48,3,32S16,3,32,3 M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32
			s32-14.3,32-32S49.7,0,32,0L32,0z"
      />

      <circle
        stroke={active ? "#ffc61e" : color}
        strokeWidth="1"
        cx="21.3"
        cy="23.3"
        r="5.8"
      />

      <circle
        stroke={active ? "#ffc61e" : color}
        strokeWidth="1"
        cx="42.7"
        cy="23.3"
        r="5.8"
      />

      <line
        stroke={active ? "#ffffff" : color}
        strokeWidth="2"
        x1="23.5"
        y1="44"
        x2="40.5"
        y2="42"
      />
    </svg>
  );
}
